import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";

const GenesisReleasePanel = ({ genesis }) => {
  const { title, totalAssets, lines, body } = genesis;

  return (
    <section className="oshar-re-genesis" aria-labelledby="oshar-re-genesis-title">
      <div className="oshar-inner">
        <div className="oshar-re-genesis__panel">
          <div className="oshar-re-genesis__art">
            <img src={VR_RE_IMAGES.master} alt="Oshar VR real estate page design reference" />
            <div className="oshar-re-genesis__art-cap">Master layout reference</div>
          </div>
          <div className="oshar-re-genesis__copy">
            <p className="oshar-re-eyebrow">Launch cadence</p>
            <h2 id="oshar-re-genesis-title" className="oshar-re-genesis__title">
              {title}
            </h2>
            <p className="oshar-re-genesis__total">
              <strong>{totalAssets.toLocaleString()}</strong> total assets in phase one
            </p>
            <ul className="oshar-re-genesis__list">
              {lines.map((row) => (
                <li key={row.label}>
                  <span>{row.label}</span>
                  <span className="oshar-re-genesis__count">{row.count.toLocaleString()}</span>
                </li>
              ))}
            </ul>
            <p className="oshar-re-genesis__body">{body}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenesisReleasePanel;
